import { Popup, PopupContent, PopupTitle } from '@tameeni/ui'
import { LoginIframe } from '@/features/authentication/components'

type Props = {
  readonly onOpenChange: (open: boolean) => void
}

export default function LoginModal({ onOpenChange }: Props) {
  return (
    <Popup open onOpenChange={onOpenChange}>
      <PopupContent
        isScrollable={false}
        className='h-fit rounded-lg bg-white p-0 *:p-0'
      >
        <PopupTitle className='sr-only'>Login</PopupTitle>
        <LoginIframe className={'h-[600px] w-full rounded-lg'} />
      </PopupContent>
    </Popup>
  )
}
